const diasNoMes = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

const mesesMin = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

function diaPorMes(mes) {
  return diasNoMes[mes - 1];
}

export default {
  meses,
  mesesMin,
  diaPorMes,
};
